import { render, staticRenderFns } from "./banner-chunk.vue?vue&type=template&id=1caec674&scoped=true"
import script from "./banner-chunk.vue?vue&type=script&lang=js"
export * from "./banner-chunk.vue?vue&type=script&lang=js"
import style0 from "./banner-chunk.vue?vue&type=style&index=0&id=1caec674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caec674",
  null
  
)

export default component.exports